import { MousePointerClick } from 'lucide-react'
import { FC } from 'react'
import styled from 'styled-components'

type PointAndClickButtonProps = {
  onClick: () => void
  isActive: boolean
}
export const PointAndClickButton: FC<PointAndClickButtonProps> = (props) => {
  return (
    <ButtonContainer onClick={props.onClick} $isActive={props.isActive}>
      <MousePointerClick size={16} />
    </ButtonContainer>
  )
}

const ButtonContainer = styled.button.attrs({
  type: 'button',
  'aria-label': 'point-and-click-button',
})<{ $isActive: boolean }>`
  height: 100%;
  cursor: pointer;
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  border: 1px solid ${({ theme }) => theme.forecast.border};
  border-radius: 0.25rem;
  opacity: 0.8;
  transition: opacity 160ms ease;
  color: ${({ theme, $isActive }) =>
    $isActive ? theme.colors.highVis : theme.forecast.defaultText};

  &:hover {
    opacity: 1;
  }
`
